import React from 'react';
import { BsAward, BsPencilSquare, BsTrash } from 'react-icons/bs';

import { fieldInputTypes } from '../../../constants/fieldInputTypes';
import { inAppText } from '../../../constants/inAppText';
import { TabNames } from '../../../constants/tabMenuTypes';
import TemplateDetailsModal from '../../../pages/TemplatesListPage/components/modals/TemplateDetailsModal';
import { hideModal, showModal } from '../../../redux/modules/modal';
import { hideTray, showTray } from '../../../redux/modules/tray';
import ConfirmActionWarningModal from '../../ConfirmActionWarningModal';
import StackedButtonGroup from '../../Modal/ModalButtonGroups/StackedButtonGroup';
import CreateCustomPolicyTypeTray
  from '../components/RequirementTemplateLeftBox/components/RequirementTemplateBuilderBodyLeft/components/TemplateBuilderPolicyPanel/components/CreateCustomPolicyTypeTray';
import CreateCustomDocumentTypeTray
  from '../components/RequirementTemplateRightBox/components/RequirementTemplateBuilderBodyRight/components/TemplateBuilderDocumentPanel/components/CreateCustomDocumentTypeTray';
import CreateCustomLanguageTray
  from '../components/RequirementTemplateRightBox/components/RequirementTemplateBuilderBodyRight/components/TemplateBuilderLanguagePanel/components/CreateCustomLanguageTray';

export const shieldedRequirementsOptions = [
  {
    label: 'Add OCIP',
    id: 'add-ocip',
    icon: BsAward,
    tooltip: inAppText.tooltips.comingSoon,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line no-console
      console.log('Add OCIP Clicked');
    }
  },
  {
    label: 'Add CCIP',
    id: 'add-ccip',
    icon: BsAward,
    tooltip: inAppText.tooltips.comingSoon,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line no-console
      console.log('Add CCIP Clicked');
    }
  },
  {
    label: 'Add Bond',
    id: 'add-bond',
    icon: BsAward,
    tooltip: inAppText.tooltips.comingSoon,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      // eslint-disable-next-line no-console
      console.log('Add Bond Clicked');
    }
  }
];

export const REQUIREMENT_TYPES = {
  Policies: 'insurance_policy_type_property',
  Documents: 'insurance_document_type',
  Language: 'insurance_language'
};

export const REQUIREMENT_TYPE_STATES = {
  Policies: 'policyTypes',
  Documents: 'documentTypes',
  Language: 'languages'
};

export const REQUIREMENT_TYPE_FILTERS = {
  Policies: { Defaults: 'defaults', Customs: 'customs' },
  Documents: { Defaults: 'defaults', Customs: 'customs' },
  Language: { Defaults: 'defaults', Customs: 'customs' }
};

export const customPolicyOptions = [
  {
    label: 'Edit Custom Policy',
    id: 'edit',
    icon: BsPencilSquare,
    handler: ({ e, dispatch, blueprint }) => {
      e.stopPropagation();
      e.preventDefault();

      const policyTypeId = e.currentTarget.value;

      dispatch(blueprint.setCreateCustomStep(0, TabNames.Policies));
      dispatch(blueprint.setEditCustomPolicyId(policyTypeId));
      dispatch(showTray(
        () => <CreateCustomPolicyTypeTray blueprint={blueprint} />,
        {
          onClose: () => {
            dispatch(blueprint.resetCreateCustomPolicyType());
            dispatch(hideTray());
          }
        }
      ));
    }
  },
  {
    label: 'Delete Custom Policy',
    id: 'delete',
    icon: BsTrash,
    handler: ({ e, dispatch, blueprint }) => {
      e.stopPropagation();
      e.preventDefault();

      const policyTypeId = e.currentTarget.value;
      const description = 'This will delete the selected from the list of Policies.';

      dispatch(showModal(
        () => <ConfirmActionWarningModal description={description} />,
        {
          title: 'Delete Custom Policy?',
          size: 'md',
          buttons: {
            component: StackedButtonGroup,
            primaryButtonOptions: {
              label: 'Delete',
              isDisabled: true,
              onClick: () => {
                dispatch(blueprint.deleteInsurancePolicyType(policyTypeId));
                dispatch(hideModal());
              }
            }
          }
        }
      ));
    }
  }
];

export const customDocumentOptions = [
  {
    label: 'Edit Custom Document',
    id: 'edit',
    icon: BsPencilSquare,
    handler: ({ e, dispatch, blueprint }) => {
      e.stopPropagation();
      e.preventDefault();

      const documentTypeId = e.currentTarget.value;

      dispatch(blueprint.setCreateCustomStep(0, TabNames.Documents));
      dispatch(blueprint.setEditCustomDocumentId(documentTypeId));
      dispatch(showTray(
        () => <CreateCustomDocumentTypeTray blueprint={blueprint} />,
        {
          onClose: () => {
            dispatch(hideTray());
            dispatch(blueprint.resetCreateCustomDocumentType());
          }
        }
      ));
    }
  },
  {
    label: 'Delete Custom Document',
    id: 'delete',
    icon: BsTrash,
    handler: ({ e, dispatch, blueprint }) => {
      e.stopPropagation();
      e.preventDefault();

      const documentTypeId = e.currentTarget.value;

      const description = 'This will delete the selected from the list of Documents.';
      dispatch(showModal(
        () => <ConfirmActionWarningModal description={description} />,
        {
          title: 'Delete Custom Document?',
          size: 'md',
          buttons: {
            component: StackedButtonGroup,
            primaryButtonOptions: {
              label: 'Delete',
              isDisabled: true,
              onClick: () => {
                dispatch(blueprint.deleteInsuranceDocumentType(documentTypeId));
                dispatch(hideModal());
              }
            }
          }
        }
      ));
    }
  }
];

export const customLanguageOptions = [
  {
    label: 'Edit Custom Language',
    id: 'edit',
    icon: BsPencilSquare,
    handler: ({ e, dispatch, blueprint }) => {
      e.stopPropagation();
      e.preventDefault();

      const languageId = e.currentTarget.value;

      dispatch(blueprint.setCreateCustomStep(0, TabNames.Language));
      dispatch(blueprint.setEditCustomLanguageId(languageId));
      dispatch(showTray(
        () => <CreateCustomLanguageTray blueprint={blueprint} />,
        {
          onClose: () => {
            dispatch(hideTray());
            dispatch(blueprint.resetCreateCustomLanguage());
          }
        }
      ));
    }
  },
  {
    label: 'Delete Custom Language',
    id: 'delete',
    icon: BsTrash,
    handler: ({ e, dispatch, blueprint }) => {
      e.stopPropagation();
      e.preventDefault();

      const languageTypeId = e.currentTarget.value;
      const description = 'This will delete the selected from the list of Languages.';

      dispatch(showModal(
        () => <ConfirmActionWarningModal description={description} />,
        {
          title: 'Delete Custom Language?',
          size: 'md',
          buttons: {
            component: StackedButtonGroup,
            primaryButtonOptions: {
              label: 'Delete',
              isDisabled: true,
              onClick: () => {
                dispatch(blueprint.deleteInsuranceLanguage(languageTypeId));
                dispatch(hideModal());
              }
            }
          }
        }
      ));
    }
  }
];

export const publishTemplateOptions = [
  {
    label: 'Save Draft',
    id: 'save_as_draft',
    icon: BsPencilSquare,
    handler: ({ e, dispatch }) => {
      e.preventDefault();
      e.stopPropagation();
      const templateId = Number(e.target.value);

      dispatch(showModal(
        () => <TemplateDetailsModal templateId={templateId} type="edit" />,
        {
          title: 'Template Details',
          size: 'lg'
        }
      ));
    }
  }
];

export const REQUIREMENT_TYPE_NAMES = {
  Policies: 'policies',
  Documents: 'documents',
  Languages: 'Languages'
};

export const horizontalTabContentBoxStyles = {
  px: '0',
  py: '0',
  bgColor: 'white',
  borderRadius: 'lg',
  overflow: 'auto'
};

export const customPolicyTypePropertyOptions = [{ displayName: 'Checkboxes', id: fieldInputTypes.Checkboxes },
  { displayName: 'Alphanumeric Input Field', id: fieldInputTypes.AlphaNumeric },
  { displayName: 'Monetary Field', id: fieldInputTypes.Monetary }];
